import { styled } from "@mui/material/styles";

import { Typography as MuiTypography } from "@mui/material"

export const TicketFormCardContainer = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  alignItems: "flex-start",
  justifyContent: "center",
  alignSelf: "stretch",
  flexGrow: 1,
  gap: theme.space._300,
}));

export const TitleTypography = styled(MuiTypography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.lg,
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim,
}));

export const TitleBadgeContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.space._200,
  minHeight: theme.space._500,
  zIndex: 1,
}));

export const TicketFormHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  alignSelf: "stretch",
  zIndex: 1,
}));

export const FormContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  alignSelf: "stretch",
  gap: theme.space._400,
  zIndex: 1,
}));

export const FieldsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  alignSelf: "stretch",
  gap: theme.space._200,
}));

export const TermsTooltipSpan = styled("span")(({ theme }) => ({
  fontWeight: theme.fontWeights.bold,
  "&:hover":{
    textDecoration: "underline"
  }
}));